import { useEffect, useRef, useState } from "react";
import KanbanView from "./kanbanView";
import CalendarView from "./calendarView";
import Tasks from "@/pages/tasks";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  PlanTypeEnumSchema,
  ProjectDefaultViewEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import kanaban from "../../assets/svg/kanBanNew.svg";
import gantt from "../../assets/svg/ganttNew.svg";
import calendar from "../../assets/svg/CalenderNewIcon.svg";
import list from "../../assets/svg/listNew.svg";
import {
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip,
} from "@/components/ui/tooltip";
import TaskFilter from "./TaskFilter";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";
import { FIELDS } from "@/api/types/enums";
import { Task } from "@/api/mutation/useTaskCreateMutation";
import { Button } from "../ui/button";
import SettingIcon from "@/assets/svg/Setting.svg";
import Expand from "@/assets/svg/expand.svg";
import Collaps from "@/assets/svg/collaps.svg";
// import Select, { SingleValue } from "react-select";
import Loader from "../common/Loader";
import NoTask from "@/pages/tasks/NoTask";
import TaskSubTaskForm from "../tasks/taskSubTaskForm";
import useAllKanbanColumnQuery from "@/api/query/useAllKanbanColumn";
import { useTranslation } from "react-i18next";
import useMultipaleTaskRemoveMutation from "@/api/mutation/useMultipleTaskRemoveMutation";
import { toast } from "react-toastify";
import { errorConfig } from "@/lib/toastError";
import Dialog from "../common/Dialog";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import useTaskMemberListQuery from "@/api/query/useTaskMemberListQuary";
import UserAvatar from "../ui/userAvatar";
import useAssingUserToMultiTaskMutation from "@/api/mutation/useAssingUserToMultiTaskMutation";
import { useUser } from "@/hooks/useUser";
import Gannt from "./custom";
import ZoomOut from "@/assets/svg/ZoomOut.svg";
import ZoomIn from "@/assets/svg/ZoomIn.svg";
import FullScreen from "@/assets/svg/FullScreen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/svg/Refresh.svg";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import ExcelJS from "exceljs";
import ExcelIcon from "@/assets/svg/Excel.svg";
import dateFormater from "@/helperFuntions/dateFormater";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import WbsImport from "../tasks/wbsImport";
import { useFormik } from "formik";
import {
  addMemberToOrgSchema,
  assignProjectAndRoleToUserSchema,
} from "@backend/src/schemas/organisationSchema";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { z } from "zod";
import useAddOrganisationMemberMutation from "@/api/mutation/useAddOrganisationMemberMutation";
import { usePlanValidation } from "@/hooks/usePlan";
import useAssignProjectAndRoleToUserMutation from "@/api/mutation/useAssignProjectAndRoleToUser";
import ShareIcon from "@/assets/svg/Share.svg";
import InputEmail from "../common/InputEmail";
import useOrganisationDetailsQuery, {
  UserOrganisationType,
} from "@/api/query/useOrganisationDetailsQuery";
import ErrorMessage from "../common/ErrorMessage";
import useProjectQuery from "@/api/query/useProjectQuery";

// const reactSelectStyle = {
//   control: (
//     provided: Record<string, unknown>,
//     state: { isFocused: boolean }
//   ) => ({
//     ...provided,
//     border: "1px solid #E7E7E7",
//     outline: state.isFocused ? "2px solid #299d91" : "1px solid #E7E7E7",
//     boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
//     "&:hover": {
//       outline: state.isFocused ? "2px solid #299d91" : "1px solid #E7E7E7",
//       boxShadow: "0px 0px 0px #299d91",
//     },
//   }),
//   option: (
//     provided: Record<string, unknown>,
//     state: { isSelected: boolean }
//   ) => ({
//     ...provided,
//     color: state.isSelected ? "white" : "black",
//     background: state.isSelected ? "#299d91" : "white",
//     "&:hover": {
//       color: "white",
//       background: "#299d9199",
//     },
//   }),
//   valueContainer: (provided: Record<string, unknown>) => ({
//     ...provided,
//     paddingRight: 0,
//   }),
//   indicatorSeparator: (provided: Record<string, unknown>) => ({
//     ...provided,
//     display: "none",
//   }),
// } as const;

export const viewOption = [
  {
    icon: list,
    value: ProjectDefaultViewEnumValue.LIST,
  },
  {
    icon: gantt,
    value: ProjectDefaultViewEnumValue.GANTT,
  },
  {
    icon: kanaban,
    value: ProjectDefaultViewEnumValue.KANBAN,
  },
  {
    icon: calendar,
    value: ProjectDefaultViewEnumValue.CALENDAR,
  },
];
function TaskViews() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  // const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  // const [filter.get(""), setViews] = useState<string>(viewOption[0].value);
  const [filter, setFilter] = useSearchParams();

  // const toggleSidebar = () => {
  //   setSidebarExpanded(!isSidebarExpanded);
  // };
  const { projectId } = useParams();
  const projectQuery = useProjectDetail(projectId, true);
  const getAllProjectQuery = useProjectQuery();
  const allTaskQuery = useAllTaskQuery(projectId);
  const [filterData, setFilterData] = useState<Task[]>();
  const [kanbanSetting, setKanbanSetting] = useState(false);
  const [filtered, setfilterd] = useState(false);
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [isOpenWorkLoad, setIsOpenWorkLoad] = useState(false);
  const [filterUnit, setFilterUnit] = useState(0);
  // const [snapToNearest, setSnapToNearest] = useState(true);
  const [isExpand, setIsExpand] = useState(false);
  const [isGanttExpand, setIsGanttExpand] = useState(false);
  const [remove, setRemove] = useState(false);

  const [selectedTask, setSelectedTask] = useState<string[]>([]);
  const allKanbanColumn = useAllKanbanColumnQuery(projectId);
  const { t, i18n } = useTranslation();
  const taskMemberList = useTaskMemberListQuery(projectId ?? "");
  const assingUserToMultiTask = useAssingUserToMultiTaskMutation();
  const { user } = useUser();

  const [roleInProject, setRoleInProject] =
    useState<keyof typeof UserRoleEnumValue>();
  const setView = (view: keyof typeof ProjectDefaultViewEnumValue) => {
    if (view == ProjectDefaultViewEnumValue.GANTT) {
      setIsGanttExpand(true);
    }
    filter.set("view", view);
    setFilter(filter);
  };

  useEffect(() => {
    allTaskQuery.refetch().then((res) => {
      setFilterData(res.data?.data.data);
    });
    allKanbanColumn.refetch();
    setIsOpenWorkLoad(false);
  }, [projectId]);
  const { validatePlan } = usePlanValidation();
  useEffect(() => {
    if (projectQuery.data?.data.data) {
      if (filter.get("view")) {
        setView(filter.get("view") as keyof typeof ProjectDefaultViewEnumValue);
      } else {
        setView(projectQuery.data.data.data.defaultView);
      }
      const role = projectQuery.data.data.data.assignedUsers.find(
        (u) => u.user.userId == user?.userId
      )?.projectRole;
      if (role) {
        setRoleInProject(role as keyof typeof UserRoleEnumValue);
      }
    }
  }, [projectQuery.data?.data.data, projectId, filter]);

  useEffect(() => {
    if (location?.state?.isGanttOpen) {
      setIsOpenWorkLoad(location?.state?.isGanttOpen);
    }
  }, [location]);

  useEffect(() => {
    if (searchParams.get("milestones")) {
      setView(viewOption[0].value as keyof typeof ProjectDefaultViewEnumValue);
    }
    if (searchParams.get("status")) {
      setView(viewOption[0].value as keyof typeof ProjectDefaultViewEnumValue);
    }
  }, [searchParams]);

  useEffect(() => {
    if (
      allTaskQuery.data &&
      allTaskQuery.data?.data.data.length > 0 &&
      filterData &&
      filterData.length == 0
    ) {
      setfilterd(true);
    } else {
      setfilterd(false);
    }
    if (
      allTaskQuery.data?.data.data.length == 0 &&
      filterData &&
      filterData?.length > 0
    ) {
      setFilterData([]);
    }
  }, [filterData, allTaskQuery.data?.data.data]);
  const useGetOrganizationUser = useOrganisationDetailsQuery(
    localStorage.getItem("organisation-id") + ""
  );
  const multipaleTaskRemoveMutation = useMultipaleTaskRemoveMutation();
  const removetask = () => {
    multipaleTaskRemoveMutation.mutate(
      { taskIds: selectedTask },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          setRemove(false);
          allTaskQuery.refetch();
          setSelectedTask([]);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  // interface RandomTask {
  //   taskName: string;
  //   taskDescription: string;
  //   startDate: Date;
  //   duration: number;
  //   subTasks?: RandomTask[];
  //   tempId: string;
  // }
  // const generateRandomTaskData = (taskNumber: number, startDate: Date, level = 0): RandomTask => {
  //   const taskName = `Task ${taskNumber}`;
  //   const taskDescription = `Description for ${taskName}`;
  //   const taskStartDate = new Date(startDate);
  //   taskStartDate.setDate(startDate.getDate() + taskNumber);
  //   const taskDuration = taskNumber + 1;

  //   const task: RandomTask = {
  //     taskName: taskName,
  //     taskDescription: taskDescription,
  //     startDate: taskStartDate,
  //     duration: taskDuration,
  //     tempId: ''
  //   };

  //   if (level < 3) { // Limit the depth of subtasks to 3 levels
  //     const numSubTasks = 2; // Fixed number of subtasks
  //     if (numSubTasks > 0) {
  //       task.subTasks = [];
  //       for (let i = 0; i < numSubTasks; i++) {
  //         task.subTasks.push(generateRandomTaskData(taskNumber * 10 + (i + 1), taskStartDate, level + 1));
  //       }
  //     }
  //   }

  //   return task;
  // };

  // const taskCreateMutation = useCreateTaskMutation("f928fa35-6c91-4a5b-94f4-3e9562b01d75");

  // const createRandomTask = (taskNumber: number, parentTaskId: string | null = null) => {
  //   const randomTaskData = generateRandomTaskData(taskNumber, new Date());

  //   randomTaskData.tempId = parentTaskId || '';

  //   taskCreateMutation.mutate(randomTaskData, {
  //     onSuccess: () => {
  //       toast.success("Random task created successfully");
  //     },
  //     onError: (error) => {
  //       toast.error(
  //         errorKeyFormate(error.response?.data.message + ""),
  //         errorConfig
  //       );
  //     },
  //   });
  // };

  // const createMultipleRandomTasks = (count: number) => {
  //   for (let i = 1; i <= count; i++) {
  //     createRandomTask(i);
  //   }
  //   // for (let i = 0; i < Math.abs(count/1.5); i++) {
  //   //   allTaskQuery.refetch().then((res) => {
  //   //     if (res.data?.data?.data) {
  //   //       const randomIndex = Math.floor(Math.random() * res.data.data.data.length);
  //   //       const randomTask = res.data.data.data[randomIndex];
  //   //       if (randomTask) {
  //   //         createRandomTask(i,randomTask.taskId);
  //   //       }
  //   //     }
  //   //   }).catch((error) => {
  //   //     console.error('Error refetching tasks:', error);
  //   //   });
  //   // }
  // };
  const [organizationUsers, setOrganizationUsers] = useState<
    UserOrganisationType[]
  >([]);
  useEffect(() => {
    setOrganizationUsers(
      useGetOrganizationUser.data?.data.data.userOrganisation ?? []
    );
  }, [useGetOrganizationUser.data?.data.data]);

  const downloadExcel = async (data: Task[]) => {
    const projectName = projectQuery.data?.data.data.projectName || "Projet";

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Feuille1");

    worksheet.columns = [
      { header: "ID", key: "id", width: 10 },
      { header: "Activites / Taches", key: "task", width: 40 },
      { header: "Date de debut (optionel)", key: "startDate", width: 20 },
      { header: "Duree (optionel)", key: "duration", width: 20 },
      { header: "Date de fin (optionnel)", key: "endDate", width: 20 },
      { header: "Assigné à", key: "assignedTo", width: 25 },
      { header: "Statut", key: "status", width: 18 },
      { header: "Progrès", key: "progress", width: 12 },
      { header: "Jalon", key: "milestone", width: 10 },
    ];

    const statusOptions = ["Non commencé", "Terminé", "En cours"];

    const flattenedTasks: {
      id: string;
      task: string;
      startDate: string;
      duration: number | string;
      endDate: string;
      assignedTo: string;
      status: string;
      progress: string;
      milestone: string;
    }[] = [];

    const formatTask = (
      task: Task,
      indexPath: string
    ): (typeof flattenedTasks)[number] => {
      const mainTask = data.find((t) => t.taskId == task.taskId);
      const assignees = (mainTask?.assignedUsers || [])
        .map((u) => {
          const { email } = u.user || {};
          return email || "";
        })
        .join(" ");

      let status = "Non commencé";
      if (task.status === TaskStatusEnumValue.COMPLETED) status = "Terminé";
      else if (task.status === TaskStatusEnumValue.IN_PROGRESS)
        status = "En cours";
      const endDate = mainTask?.endDate;
      return {
        id: indexPath,
        task: task.taskName,
        startDate: task.startDate ? dateFormater(task.startDate) : "",
        duration: task.duration || "",
        endDate: dateFormater(new Date(endDate ?? "")),
        assignedTo: assignees,
        status,
        progress: Number(task.completionPecentage).toFixed(),
        milestone: task.milestoneIndicator ? "true" : "false",
      };
    };

    const traverseTasks = (tasks: Task[], prefix = "") => {
      tasks.forEach((task, i) => {
        const idPath = prefix ? `${prefix}.${i + 1}` : `${i + 1}`;
        flattenedTasks.push(formatTask(task, idPath));
        if (task.subtasks?.length) {
          traverseTasks(task.subtasks, idPath);
        }
      });
    };

    traverseTasks(
      data
        .filter((t) => !t.parentTaskId)
        .sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
    );

    flattenedTasks.forEach((taskRow) => {
      const row = worksheet.addRow(taskRow);

      const isParent = /^\d+$/.test(taskRow.id); // IDs like "1", "2" only

      if (isParent) {
        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B9E1CB" }, // Light Green
          };
          cell.font = { bold: true };
        });
      }
    });

    worksheet.eachRow((_, rowNumber) => {
      if (rowNumber === 1) return;

      worksheet.getCell(`G${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${statusOptions.join(",")}"`],
        showErrorMessage: true,
      };

      worksheet.getCell(`I${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"true,false"'],
        showErrorMessage: true,
      };
    });

    // Set header row styling
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "62BD8A" }, // Dark Green
      };
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" }, // White
      };
      cell.border = {
        top: { style: "thin", color: { argb: "006400" } },
        left: { style: "thin", color: { argb: "006400" } },
        bottom: { style: "thin", color: { argb: "006400" } },
        right: { style: "thin", color: { argb: "006400" } },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${projectName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  const submitMultiTaskAssing = (selectedUser: string) => {
    assingUserToMultiTask.mutate(
      { assignedToUserId: selectedUser, data: { taskIds: selectedTask } },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          allTaskQuery.refetch();
          setSelectedTask([]);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  const fullScreen = useRef<HTMLDivElement | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);
  useEffect(() => {
    const taskId = filter.get("task");

    if (taskId) {
      setIsOpenPopUp(true);
    }
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };
  const [newTask, setNewTask] = useState("");
  const [dataSource, setDataSource] = useState<Task[]>();
  useEffect(() => {
    setDataSource(allTaskQuery.data?.data.data);
  }, [allTaskQuery.data?.data.data]);
  const selectedView = filter.get("view");
  const selectedItem = viewOption.find((item) => item.value === selectedView);

  const addOrganisationMemberMutation = useAddOrganisationMemberMutation(
    localStorage.getItem("organisation-id") ?? ""
  );
  const assignProjectAndRoleToUserMutation =
    useAssignProjectAndRoleToUserMutation();

  const addOrgMemberForm = useFormik<z.infer<typeof addMemberToOrgSchema>>({
    initialValues: {
      email: "",
      language: i18n.language.toUpperCase() as "FR" | "EN",
      isAdmin: false,
      isCollaborator: true,
    },
    validationSchema: toFormikValidationSchema(addMemberToOrgSchema),
    onSubmit: (values, helper) => {
      if (!validatePlan("member").valid) {
        return;
      }

      addOrganisationMemberMutation.mutate(
        { ...values, isCollaborator: true },
        {
          onSuccess(data) {
            toast.success(errorKeyFormate(data.data.message));
            projectQuery.refetch();
            helper.resetForm();
            const createData = {
              userOrganisationId:
                data.data.data.userOrganisation[0].userOrganisationId ?? "",
              data: {
                arrayOfRoleAndProjectId: [
                  {
                    projectId: projectId ?? "",
                    projectRoleForUser: UserRoleEnumValue.COLLABORATOR,
                  },
                ],
                isRoleChangePmToTm: false,
                isCollaborator: true,
              },
            };
            assignToProject(createData);
          },
          onError(error) {
            if (error) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        }
      );
    },
  });

  const assignToProject = (createData: {
    userOrganisationId: string;
    data: z.infer<typeof assignProjectAndRoleToUserSchema>;
  }) => {
    assignProjectAndRoleToUserMutation.mutate(createData, {
      onSuccess(data) {
        toast.success(errorKeyFormate(data.data.message));
        if (data.data.data.isChargeApplied) {
          toast.success(errorKeyFormate(data.data.data.additionalMessage), {
            autoClose: false,
          });
        }

        projectQuery.refetch();
      },
      onError(error) {
        toast.error(
          error.response?.data.message == "Unauthorized"
            ? t(
                "You are not authorized to edit tasks which are not assigned to you"
              )
            : errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };
  const [showViewList, setShowViewList] = useState(false);
  const navigate = useNavigate();
  const toggleWorkload = () => {
    if (
      !user?.subscription ||
      !user?.subscription?.planType ||
      user?.subscription?.planType == PlanTypeEnumSchema.FREE
    ) {
      navigate(`/workload/${projectId}?view=GANTT`);
    } else {
      setIsOpenWorkLoad(!isOpenWorkLoad);
    }
  };
  return (
    <div ref={fullScreen} className="h-full overflow-hidden bg-white relative">
      <div className=" h-full overflow-hidden bg-white">
        {(filter.get("view") == ProjectDefaultViewEnumValue.GANTT
          ? !allTaskQuery.isFetched
          : allKanbanColumn.isRefetching ||
            allTaskQuery.isFetching ||
            allTaskQuery.isRefetching ||
            filterData === undefined) && (
          <Loader className="absolute top-0 left-0 bg-white z-30" />
        )}
        <div
          className={`h-full ml-4 flex flex-col  justify-between items-center gap-0 my-1 `}
        >
          {allTaskQuery.data && allTaskQuery.data.data.data.length > 0 && (
            <div className="flex justify-between items-center w-full">
              <div className="flex items-center gap-2">
                {selectedTask.length > 0 && (
                  <Button
                    variant={"destructive"}
                    onClick={() => setRemove(true)}
                    className=" ml-2"
                    size={"sm"}
                  >
                    {t("remove")}
                  </Button>
                )}
                {selectedTask.length > 0 && (
                  <>
                    <Popover>
                      <PopoverTrigger className="w-fit">
                        <Button variant={"outline"} className=" " size={"sm"}>
                          {t("Assign to members")}
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="w-fit focus:outline-none">
                        <div className="grid gap-4">
                          <div className="space-y-2">
                            <h4 className="font-medium leading-none">
                              {t("members")}
                            </h4>
                          </div>
                          <div>
                            {taskMemberList.data?.data.data.map(
                              (data, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={`flex items-center p-1 my-1 gap-4 hover:bg-slate-100 rounded-md`}
                                    onClick={() => {
                                      submitMultiTaskAssing(data.user.userId);
                                    }}
                                  >
                                    <UserAvatar
                                      user={data.user}
                                      className="rounded-full"
                                    />
                                    <div>
                                      <div className="">
                                        {data.user.firstName}{" "}
                                        {data.user.lastName}
                                      </div>
                                      <div className="text-sm text-gray-400">
                                        {data.user.email}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </>
                )}
                <TaskFilter
                  tasks={dataSource}
                  fieldToShow={[
                    FIELDS.ASSIGNED,
                    FIELDS.DATE,
                    FIELDS.DUESEVENDAYS,
                    FIELDS.FLAGS,
                    FIELDS.OVERDUEDAYS,
                    FIELDS.TODAYDUEDAYS,
                    FIELDS.TASK,
                    FIELDS.STATUS,
                  ]}
                  small={selectedTask.length > 0}
                  view={filter.get("view") ?? ""}
                  filteredData={setFilterData}
                />
                {/* {
                  <Button variant={"destructive"} onClick={()=>createMultipleRandomTasks(100)}>create rendomtask</Button>
                } */}
                {filter.get("view") == ProjectDefaultViewEnumValue.KANBAN &&
                  roleInProject &&
                  !(
                    roleInProject == UserRoleEnumValue.COLLABORATOR ||
                    roleInProject == UserRoleEnumValue.TEAM_MEMBER
                  ) && (
                    <div className="my-auto ml-10">
                      <Button
                        variant={"ghost"}
                        size={"sm"}
                        onClick={() => setKanbanSetting(!kanbanSetting)}
                        className="p-0 pr-2  !h-9 mt-2"
                      >
                        <img
                          src={SettingIcon}
                          className="h-9 mr-2 brightness-0"
                        />{" "}
                        {t("setting")}
                      </Button>
                    </div>
                  )}
                {filter.get("view") == ProjectDefaultViewEnumValue.GANTT && (
                  <div className="flex justify-end items-center gap-1 my-2 w-full ">
                    {roleInProject !== UserRoleEnumValue.COLLABORATOR && (
                      <Button
                        variant={"primary"}
                        onClick={() => setIsOpenPopUp(true)}
                        className=" "
                        size={"sm"}
                      >
                        {t("Add_New_Task")}
                      </Button>
                    )}
                    {filterData?.some((d) => d.parentTaskId) && (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <li className="flex-1 list-none">
                              <Button
                                variant={"none"}
                                onClick={() =>
                                  setIsGanttExpand((prev) => !prev)
                                }
                                className=" !p-1"
                                size={"sm"}
                              >
                                <img
                                  src={!isGanttExpand ? Collaps : Expand}
                                  alt=""
                                  className="w-5 min-w-5"
                                />
                              </Button>
                            </li>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">
                              {t(!isGanttExpand ? "expand" : "collapse")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )}
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <li className="flex-1 list-none ">
                            <Button
                              variant={"none"}
                              className="select-none !p-1"
                              disabled={filterUnit == 0}
                              onClick={() => setFilterUnit((prev) => prev - 1)}
                            >
                              <img src={ZoomIn} className="w-4 min-w-4" />
                            </Button>
                          </li>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("zoomin")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <li className="flex-1 list-none">
                            <Button
                              variant={"none"}
                              className="select-none  !p-1"
                              disabled={filterUnit == 3}
                              onClick={() => setFilterUnit((prev) => prev + 1)}
                            >
                              <img src={ZoomOut} className="w-4 min-w-4" />
                            </Button>
                          </li>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("zoomout")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                )}
                {filter.get("view") == ProjectDefaultViewEnumValue.LIST && (
                  <div
                    className={`flex gap-3 items-center ${
                      selectedTask.length == 0 ? "" : "ml-2"
                    }`}
                  >
                    {selectedTask.length == 0 &&
                      roleInProject !== UserRoleEnumValue.COLLABORATOR && (
                        <Button
                          variant={"primary"}
                          onClick={() => setIsOpenPopUp(true)}
                          className=" "
                          size={"sm"}
                        >
                          {t("Add_New_Task")}
                        </Button>
                      )}
                  </div>
                )}
                {filterData?.some((d) => d.parentTaskId) &&
                  filter.get("view") == ProjectDefaultViewEnumValue.LIST && (
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <li className="flex-1 list-none">
                            <Button
                              variant={"none"}
                              onClick={() => setIsExpand(!isExpand)}
                              className=" !p-1"
                              size={"sm"}
                            >
                              <img
                                src={!isExpand ? Collaps : Expand}
                                alt=""
                                className="w-5 min-w-5"
                              />
                            </Button>
                          </li>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">
                            {t(!isExpand ? "expand" : "collapse")}
                          </p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  )}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="flex-1 list-none">
                        <Button
                          variant={"none"}
                          className="select-none  !p-1"
                          onClick={() => enterFullscreen()}
                        >
                          <img
                            src={!isFullscreen ? FullScreen : ExitFullscreen}
                            className={`${
                              !isFullscreen ? "w-5 min-w-5" : "w-3.5 min-w-3.5"
                            }`}
                          />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">
                        {t(!isFullscreen ? "full_Screen" : "full_exit_screen")}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="flex-1 list-none">
                        <Button
                          variant={"none"}
                          className="select-none  !p-1"
                          onClick={() => allTaskQuery.refetch()}
                        >
                          <img src={Refresh} className={`w-3.5 min-w-3.5`} />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">{t("reload")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
                {roleInProject !== UserRoleEnumValue.COLLABORATOR &&
                  roleInProject !== UserRoleEnumValue.TEAM_MEMBER && (
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <li className="flex-1 list-none">
                            <Popover
                              onOpenChange={(e) => {
                                if (!e) {
                                  addOrgMemberForm.setFieldError("email", "");
                                }
                              }}
                            >
                              <PopoverTrigger>
                                <div>
                                  <Button
                                    variant={"none"}
                                    className="select-none  !p-1"
                                  >
                                    <img
                                      src={ShareIcon}
                                      className={`w-4 min-w-4`}
                                    />
                                  </Button>
                                </div>
                              </PopoverTrigger>
                              <PopoverContent>
                                <div className="flex flex-col gap-2 ">
                                  <h2>{t("Add as Collaborator")}</h2>
                                  <div>
                                    <label className="text-xs">
                                      {t("email")}
                                    </label>
                                    <InputEmail
                                      name="email"
                                      onChange={addOrgMemberForm.handleChange}
                                      onBlur={addOrgMemberForm.handleBlur}
                                    />
                                    <ErrorMessage>
                                      {addOrgMemberForm.touched.email &&
                                        addOrgMemberForm.errors.email}
                                    </ErrorMessage>
                                  </div>
                                  <div className="flex w-full justify-end">
                                    <Button
                                      variant={"primary"}
                                      className="ml-auto"
                                      disabled={
                                        !addOrgMemberForm.values.email ||
                                        !addOrgMemberForm.isValid
                                      }
                                      onClick={() => {
                                        const orgUser = organizationUsers.find(
                                          (t) =>
                                            t.user.email.trim() ==
                                            addOrgMemberForm.values.email.trim()
                                        );
                                        if (orgUser) {
                                          const userEmail =
                                            addOrgMemberForm.values.email.trim();

                                          const arrayOfRoleAndProjectId =
                                            getAllProjectQuery.data?.data.data
                                              ?.filter(
                                                (p) => p.projectId !== projectId
                                              )
                                              .map((p) => {
                                                const role =
                                                  p.assignedUsers.find(
                                                    (u) =>
                                                      u.user.email.trim() ===
                                                      userEmail
                                                  )?.projectRole;

                                                if (
                                                  role === "ADMINISTRATOR" ||
                                                  role === "PROJECT_MANAGER" ||
                                                  role === "TEAM_MEMBER" ||
                                                  role === "COLLABORATOR"
                                                ) {
                                                  return {
                                                    projectId: p.projectId,
                                                    projectRoleForUser: role,
                                                  };
                                                }

                                                return null; // Skip if user is not assigned
                                              })
                                              .filter(
                                                (
                                                  item
                                                ): item is {
                                                  projectId: string;
                                                  projectRoleForUser: keyof typeof UserRoleEnumValue;
                                                } => item !== null
                                              );

                                          const createData = {
                                            userOrganisationId:
                                              orgUser.userOrganisationId ?? "",
                                            data: {
                                              arrayOfRoleAndProjectId: [
                                                ...(arrayOfRoleAndProjectId ??
                                                  []),
                                                {
                                                  projectId: projectId ?? "",
                                                  projectRoleForUser:
                                                    UserRoleEnumValue.COLLABORATOR,
                                                },
                                              ],
                                              isRoleChangePmToTm: false,
                                              isCollaborator: true,
                                            },
                                          };

                                          assignToProject(createData);
                                        } else {
                                          addOrgMemberForm.handleSubmit();
                                        }
                                      }}
                                    >
                                      {t("submit")}
                                    </Button>
                                  </div>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </li>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("shareToCollaborator")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  )}
                <WbsImport
                  projectId={projectId ?? ""}
                  refetch={allTaskQuery.refetch}
                  iconOnly
                  newTask={(task: Task[]) => {
                    const tasks = task.sort(
                      (a, b) =>
                        new Date(a?.startDate).getTime() -
                        new Date(b?.startDate).getDate()
                    );
                    setNewTask(tasks[0].taskId);
                  }}
                />

                <div>
                  <TooltipProvider>
                    <Tooltip delayDuration={0}>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className=" !p-1"
                            onClick={() => downloadExcel(filterData ?? [])}
                          >
                            <img
                              src={ExcelIcon}
                              className="w-4 min-w-4 mr-0.5"
                            />
                            <img
                              src={DownLoadIcon}
                              className="w-2 min-w-2 mt-2"
                            />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("export your task")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
                {/* {filter.get("view") == ProjectDefaultViewEnumValue.GANTT && ( */}
                <Button
                  variant={isOpenWorkLoad ? "primary" : "primary_outline"}
                  onClick={() => {
                    if (
                      filter.get("view") == ProjectDefaultViewEnumValue.GANTT
                    ) {
                      toggleWorkload();
                    } else {
                      navigate(
                        `/tasks/${projectId}?view=${ProjectDefaultViewEnumValue.GANTT}`
                      );
                      setIsOpenWorkLoad(true);
                    }
                  }}
                  className="h-fit text-xs py-1"
                  size={"sm"}
                >
                  {t("Work load")}
                </Button>
                {/* )} */}
              </div>

              <div className="flex justify-between px-4 mt-2 items-center ">
                <ul className="flex items-center gap-3 text-sm font-medium mr-10">
                  {/* <div className="text-[#787486] text-[16px]">{t("Views")}</div> */}
                  <Popover open={showViewList} onOpenChange={setShowViewList}>
                    <PopoverTrigger className="w-full text-left">
                      <button
                        className={`text-gra relative flex items-center justify-center px-2 py-[0.4rem] h-fit gap-2 rounded-xl border border-gray-300/50 shadow-lg hover:text-gray-700 ${
                          selectedView ? "bg-gray-50" : "bg-gray-50"
                        }`}
                      >
                        {selectedItem ? (
                          <>
                            <img
                              src={selectedItem.icon}
                              className="w-6 min-w-6 opacity-70"
                              style={{ filter: "brightness(0%)" }}
                            />
                            <span className="text-sm">
                              {t(selectedItem.value.toLowerCase())}
                            </span>
                          </>
                        ) : (
                          <span className="text-sm">{t("Select View")}</span>
                        )}
                      </button>
                    </PopoverTrigger>

                    <PopoverContent className="p-2">
                      <ul className="space-y-1">
                        {viewOption.map((item) => {
                          const isSelected = item.value === selectedView;
                          return (
                            <TooltipProvider key={item.value}>
                              <Tooltip delayDuration={0}>
                                <TooltipTrigger asChild>
                                  <li>
                                    <button
                                      onClick={() => {
                                        setView(
                                          item.value as keyof typeof ProjectDefaultViewEnumValue
                                        );
                                        setIsExpand(false);
                                        setSelectedTask([]);
                                        setShowViewList(false);
                                        setIsOpenWorkLoad(false);
                                      }}
                                      className={`text-gra w-full relative flex items-center justify-start px-2 py-1.5 gap-2 rounded-xl  hover:text-gray-700 ${
                                        isSelected
                                          ? "bg-primary-500 shadow-md"
                                          : "bg-gray-50"
                                      }`}
                                    >
                                      <img
                                        src={item.icon}
                                        className="w-6 min-w-6"
                                        style={{
                                          filter: isSelected
                                            ? "brightness(100000%)"
                                            : "none",
                                        }}
                                      />
                                      <span
                                        className={`text-sm ${
                                          isSelected
                                            ? "text-white font-semibold"
                                            : ""
                                        }`}
                                      >
                                        {t(item.value.toLowerCase())}{" "}
                                        {t("View")}
                                      </span>
                                    </button>
                                  </li>
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm">
                                    {t(item.value.toLowerCase())} {t("View")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          );
                        })}
                      </ul>
                    </PopoverContent>
                  </Popover>
                </ul>
              </div>
            </div>
          )}
          <div className="h-full overflow-hidden px-2 py-0 w-full relative ">
            {filterData?.length == 0 ? (
              <div className="absolute top-0 left-0  w-full h-full bg-white">
                <NoTask
                  setIsOpenPopUp={setIsOpenPopUp}
                  key={projectId}
                  projectId={projectId ?? ""}
                  refetch={() => allTaskQuery.refetch()}
                  filtered={filtered}
                />
              </div>
            ) : (
              <div className="h-full w-full">
                {filter.get("view") == ProjectDefaultViewEnumValue.KANBAN &&
                  filterData &&
                  filterData?.length && (
                    <KanbanView
                      userRole={roleInProject}
                      data={filterData ?? []}
                      openSetting={kanbanSetting}
                      refetch={() => allTaskQuery.refetch()}
                      rowTasksData={allTaskQuery.data?.data.data}
                    />
                  )}
                {filter.get("view") == ProjectDefaultViewEnumValue.LIST &&
                  filterData &&
                  filterData?.length && (
                    <Tasks
                      data={filterData ?? []}
                      expandChild={
                        filterData?.length !== dataSource?.length
                          ? true
                          : isExpand
                      }
                      selectedTask={setSelectedTask}
                      key={filtered ? "filtered" : "view"}
                    />
                  )}
                {filter.get("view") == ProjectDefaultViewEnumValue.CALENDAR && (
                  <CalendarView
                    key={projectId}
                    data={filterData ?? []}
                    refetch={() => allTaskQuery.refetch()}
                  />
                )}
                {filter.get("view") == ProjectDefaultViewEnumValue.GANTT &&
                  filterData?.length && (
                    <div className="h-full w-full">
                      <Gannt
                        setFilterUnit={setFilterUnit}
                        FilterUnit={filterUnit}
                        data={filterData ?? []}
                        refetch={allTaskQuery.refetch}
                        expandAll={isGanttExpand}
                        popUpClose={isOpenPopUp}
                        isRefetching={allTaskQuery.isFetching}
                        selectedTaskId={newTask}
                        IsOpenWorkLoad={isOpenWorkLoad}
                      />
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isOpenPopUp && (
        <TaskSubTaskForm
          key={"view" + filter}
          taskId={filter.get("task") ?? ""}
          projectId={projectId}
          close={(taskId) => {
            allTaskQuery.refetch().then(() => {
              setNewTask(taskId);
            });
            setFilter({ view: filter.get("view") ?? "" });
            setIsOpenPopUp(!isOpenPopUp);
          }}
        />
      )}
      <Dialog isOpen={remove} onClose={() => {}} modalClass="rounded-lg">
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={multipaleTaskRemoveMutation.isPending}
              disabled={multipaleTaskRemoveMutation.isPending}
              onClick={() => setRemove(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removetask}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default TaskViews;
